import { ConversionArrowIcon } from '../../../../assets/icons';
import AssetInput from '../../../../components/AssetInput';
import Button from '../../../../components/Button';
import Card from '../../../../components/Card';
import { config } from '../../../../config/config';
import { Tokens } from '../../../../config/constants';
import usePoolState from '../../../../context/pool/usePoolState';
import { formatUSD } from '../../../../helpers';
import { preventOverflow } from '../../../../web3/utils';
import { useEffect } from 'react';
// import useUserLockUps from '../../../../hooks/web3/pools/useUserLockUps';
import useMockUserLockUps from '../../../../hooks/web3/pools/useMockUserLockUps';
import clsx from 'clsx';
import { formatUnits, parseUnits } from 'ethers/lib/utils';
import Spinner from '../../../../components/Spinner';

const WithdrawInterface = () => {
    const {
        selectedLiquidityPool,
        withdrawAmount,
        selectedLockUp,
        setSelectedLockUp,
        setWithdrawAmount,
        resetPoolState,
    } = usePoolState();

    // const { userLockUps } = useUserLockUps();
    const { userLockUps } = useMockUserLockUps();

    const unlockedLp =
        userLockUps && selectedLiquidityPool
            ? userLockUps[selectedLiquidityPool.poolId].details.find(
                  ({ lockUp }) => lockUp?.duration === selectedLockUp.duration
              )?.unlockedLp
            : undefined;

    const converted = selectedLiquidityPool
        ? selectedLiquidityPool.isZeroPrice
            ? '0'
            : formatUnits(
                  parseUnits(withdrawAmount || '0', selectedLiquidityPool?.decimals)
                      .mul(
                          parseUnits(
                              selectedLiquidityPool.currentPriceEstimate,
                              selectedLiquidityPool?.decimals
                          )
                      )
                      .div(parseUnits('1', selectedLiquidityPool?.decimals)),
                  selectedLiquidityPool?.decimals
              )
        : undefined;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;

        setWithdrawAmount(preventOverflow(value, selectedLiquidityPool?.decimals));
    };

    const handleMax = () => (unlockedLp ? setWithdrawAmount(unlockedLp) : undefined);

    useEffect(() => () => resetPoolState(), [resetPoolState]);

    return selectedLiquidityPool && userLockUps ? (
        <Card className='withdraw-interface'>
            <div className='lock-up-options-container'>
                {config.lockUpOptions.map((lockUp, index) => {
                    const active = selectedLockUp.lockUpId === lockUp.lockUpId;

                    return (
                        <Button
                            key={index}
                            className={clsx('lock-up-option', {
                                active,
                            })}
                            onClick={() => setSelectedLockUp(lockUp)}
                            disabled={active}
                        >
                            {lockUp.duration === undefined
                                ? 'No Lock'
                                : `${lockUp.duration} days`}
                        </Button>
                    );
                })}
            </div>
            <div className='conversion-container'>
                <AssetInput
                    asset={selectedLiquidityPool.lpToken}
                    label={
                        <>
                            <span>Unlocked:</span>&nbsp;
                            <span>
                                {unlockedLp
                                    ? formatUSD(unlockedLp, {
                                          minDecimals: 2,
                                          currency: '',
                                      })
                                    : '-'}{' '}
                                {selectedLiquidityPool.lpToken}
                            </span>
                        </>
                    }
                    sideLabel={
                        <Button className='max-available' onClick={handleMax}>
                            Max
                        </Button>
                    }
                    name='balance'
                    value={withdrawAmount}
                    onChange={handleChange}
                />
                <ConversionArrowIcon />
                <AssetInput
                    name='usdc-amount'
                    value={
                        converted && withdrawAmount
                            ? formatUSD(converted, { minDecimals: 2, currency: '' })
                            : ''
                    }
                    asset={Tokens.USDC}
                    label='Receive'
                    readOnly
                    type='text'
                />
            </div>
            <div className='conversion-detail'>
                <div className='detail'>
                    <div className='title'>Ratio</div>
                    <div className='value'>
                        {formatUSD(1, { minDecimals: 2, currency: '' })} {Tokens.USDC} ={' '}
                        {formatUSD(
                            selectedLiquidityPool.isZeroPrice
                                ? '1'
                                : selectedLiquidityPool.currentLpPriceEstimate,
                            {
                                minDecimals: 2,
                                currency: '',
                            }
                        )}{' '}
                        {selectedLiquidityPool.lpToken}
                    </div>
                </div>
            </div>
        </Card>
    ) : (
        <Card className='withdraw-interface'>
            <div className='loading-container'>
                <Spinner />
            </div>
        </Card>
    );
};

export default WithdrawInterface;
